import { Plugins } from '@capacitor/core';
const { PaystackCapacitor } = Plugins;
export class PaystackPlugin {
    addChargeParameters(parameters) {
        return PaystackCapacitor.addChargeParameters(parameters);
    }
    getCardType() {
        return PaystackCapacitor.getCardType();
    }
    putChargeMetadata(metadata) {
        return PaystackCapacitor.putChargeMetadata(metadata);
    }
    putChargeCustomFields(customFields) {
        return PaystackCapacitor.putChargeCustomFields(customFields);
    }
    setChargeEmail(payload) {
        return PaystackCapacitor.setChargeEmail(payload);
    }
    setAccessCode(payload) {
        return PaystackCapacitor.setAccessCode(payload);
    }
    setChargeAmount(payload) {
        return PaystackCapacitor.setChargeAmount(payload);
    }
    initialize(payload) {
        return PaystackCapacitor.initialize(payload);
    }
    addCard(payload) {
        const cardData = {
            cardNumber: payload.cardNumber,
            expiryMonth: payload.expiryMonth,
            expiryYear: payload.expiryYear,
            cvv: payload.cvv
        };
        return PaystackCapacitor.addCard(cardData);
    }
    validateCard() {
        return PaystackCapacitor.validateCard();
    }
    chargeCard() {
        return PaystackCapacitor.chargeCard();
    }
}
//# sourceMappingURL=Plugin.js.map